(function () {
  var KEY = 'fbtr-country';
  var box = document.getElementById('fbtr-country');
  if (!box) return;
  var flags = box.querySelectorAll('[data-fbtr-country-choose]');
  var current = 'ZA';

  function stored() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
  function store(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
  function select(code) {
    current = code;
    flags.forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-fbtr-country-choose') === code ? 'true' : 'false'); });
  }
  function paintHeader() {
    var code = stored() || 'ZA';
    document.querySelectorAll('[data-fbtr-country-open]').forEach(function (btn) {
      var tpl = box.querySelector('[data-fbtr-country-choose="' + code + '"]');
      var flag = btn.querySelector('.fbtr-country-btn__flag');
      if (tpl && flag) flag.innerHTML = tpl.innerHTML;
      btn.setAttribute('aria-label', tpl ? tpl.getAttribute('aria-label') : 'Country');
    });
  }
  function open() { select(stored() || 'ZA'); box.hidden = false; document.body.classList.add('fbtr-country-open'); }
  function close() { box.hidden = true; document.body.classList.remove('fbtr-country-open'); store(current); paintHeader(); }

  document.addEventListener('click', function (e) {
    var choose = e.target.closest('[data-fbtr-country-choose]');
    if (choose) { select(choose.getAttribute('data-fbtr-country-choose')); return; }
    if (e.target.closest('[data-fbtr-country-open]')) { open(); return; }
    if (e.target.closest('[data-fbtr-country-close],[data-fbtr-country-apply]') || e.target === box) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) close(); });

  paintHeader();
  if (!stored()) open();
})();
